module.exports = __webpack_public_path__ + "img/btn_menu_jxs.e520ef45.png";